import { introData } from './mock/introData.js';

angular.module('Toke').factory('introRepository', function ($q) {

    function getIntro() {
        return $q.resolve(introData)
    }

    // para lista futura
    // function getIntroFromList() {

    //     const listUrl =
    //         baseUrl +
    //         "/_api/web/lists/getbytitle('Intro')/items" +
    //         "?$select=Title,Url,ParentId,Order,IsActive" +
    //         "&$orderby=Order asc";

    //     return $http({
    //         method: 'GET',
    //         url: listUrl,
    //         headers: {
    //             Accept: 'application/json;odata=nometadata'
    //         }
    //     }).then(function (response) {
    //         return response.data.value;
    //     });
    // }



    return {
        getIntro: getIntro
    };

});

